import React from 'react';
import CategoryIconPicker from '../categories/CategoryIconPicker';

const SubcategoryIconPicker = (props) => (
  <CategoryIconPicker label="Subcategory icon" {...props} />
);

export default SubcategoryIconPicker;
